import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { Row, Col, Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Footer from "./footer";
import Header from "./header";
import { studentview, teacherview, transportattendancelist } from "../service/dashboard";
import moment from "moment";
import { toast } from "react-toastify";

const TransportAttendance = () => {
    const [attendanceData, setAttendanceData] = useState({});
    const [academyId, setAcademyId] = useState(null);
    const [vdetail, setVDetail] = useState(null);
    const [enteredList, setEnteredList] = useState([]); // student attendance entered by this teacher
    const [modalGroup, setModalGroup] = useState(null); // selected date batch for the card view

    const formatDate = (date) => {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
    };

    useEffect(() => {
        const role = localStorage.getItem("Role");
        const uid = localStorage.getItem("UID");
        const startDate = moment().startOf("month").format("YYYY-MM-DD");
        const endDate = moment().endOf("month").format("YYYY-MM-DD");

        if (role === "4") {
            studentview(uid).then((res) => {
                if (res.status === true) {
                    const det = res.data.details;
                    setAcademyId(det.academy_id);
                    setVDetail(det);
                    fetchAttendance(startDate, endDate, role, det.academy_id);
                }
            });
        } else if (role === "5") {
            teacherview(uid).then((res) => {
                if (res.status === true) {
                    const det = res.data.details;
                    setAcademyId(det.academy_id);
                    setVDetail(det);
                    fetchAttendance(startDate, endDate, role, det.academy_id);
                    fetchEnteredList(startDate, endDate, det.academy_id);
                }
            });
        }
    }, []);

    // Student transport attendance entered by this teacher
    function fetchEnteredList(startDate, endDate, aca) {
        const temp = new FormData();
        temp.append("from_date", startDate);
        temp.append("to_date", endDate);
        temp.append("role_id", 4);
        temp.append("created_by", localStorage.getItem("UID"));
        temp.append("academy_id", aca);
        transportattendancelist(temp).then((res) => {
            if (res && res.status === true && res.data.details.length > 0) {
                setEnteredList(res.data.details);
            } else {
                setEnteredList([]);
            }
        });
    }

    function fetchAttendance(startDate, endDate, role, aca) {
        const temp = new FormData();
        temp.append("from_date", startDate);
        temp.append("to_date", endDate);
        temp.append("role_id", role);
        temp.append("user_id", localStorage.getItem("UID"));
        transportattendancelist(temp).then((res) => {
            if (res && res.status === true && res.data.details.length > 0) {
                const map = {};
                res.data.details.forEach((item) => {
                    const date = item.attendance_date;
                    const session = item.attendance_time ? item.attendance_time.toLowerCase() : "morning";
                    const status = item.attend_status == 1 ? "present" : "absent";
                    if (!map[date]) map[date] = {};
                    map[date][session] = status;
                });
                setAttendanceData(map);
            } else {
                setAttendanceData({});
            }
        });
    }

    const handleMonthChange = ({ activeStartDate, view }) => {
        if (view !== "month" || !academyId) return;
        const role = localStorage.getItem("Role");
        const startDate = formatDate(activeStartDate);
        const endDate = formatDate(new Date(activeStartDate.getFullYear(), activeStartDate.getMonth() + 1, 0));
        fetchAttendance(startDate, endDate, role, academyId);
        if (role === "5") {
            fetchEnteredList(startDate, endDate, academyId);
        }
    };

    const tileContent = ({ date, view }) => {
        if (view !== "month") return null;
        const key = formatDate(date);
        const day = attendanceData[key];
        if (!day) return null;

        return (
            <div className="attendance-dots">
                {day.morning && (
                    <span
                        className={`dot ${day.morning === "present" ? "present" : "absent"}`}
                        title={`Morning: ${day.morning}`}
                    >
                        {day.morning === "present" ? "P" : "A"}
                    </span>
                )}
                {day.afternoon && (
                    <span
                        className={`dot ${day.afternoon === "present" ? "present" : "absent"}`}
                        title={`Afternoon: ${day.afternoon}`}
                    >
                        {day.afternoon === "present" ? "P" : "A"}
                    </span>
                )}
                {day.evening && (
                    <span
                        className={`dot ${day.evening === "present" ? "present" : "absent"}`}
                        title={`Evening: ${day.evening}`}
                    >
                        {day.evening === "present" ? "P" : "A"}
                    </span>
                )}
            </div>
        );
    };

    const totalDays = Object.keys(attendanceData).length;
    const presentCount = Object.values(attendanceData).filter(
        (d) => d.morning === "present" || d.afternoon === "present" || d.evening === "present"
    ).length;
    const absentCount = Object.values(attendanceData).reduce((total, d) => {
        const sessions = [d.morning, d.afternoon, d.evening].filter(Boolean);
        const absentSessions = sessions.filter(s => s === "absent").length;
        const totalSessions = sessions.length;
        if (totalSessions === 0) return total;
        return total + (absentSessions / totalSessions);
    }, 0);

    // Group the entered student attendance into date/time/route/vehicle batches
    const groupedEntered = Object.values(
        enteredList.reduce((acc, item) => {
            const key = `${item.attendance_date}|${item.attendance_time}|${item.route_id}|${item.vehicle_id}`;
            if (!acc[key]) {
                acc[key] = {
                    key,
                    attendance_date: item.attendance_date,
                    attendance_time: item.attendance_time,
                    vehroute_name: item.vehroute_name,
                    vehicle_no: item.vehicle_no,
                    students: [],
                };
            }
            acc[key].students.push(item);
            return acc;
        }, {})
    ).sort((a, b) => (a.attendance_date < b.attendance_date ? 1 : -1));

    return (
        <div id="mainpage">
            <div className="maincontent">
                <Header />

                <div className="moreheading">
                    <Row className="row-sm align-items-center">
                        <Col xs={12} sm={6} className="text-left mb-2 mb-sm-0">
                            <h4 className="morehead-text mb-0">Transport Attendance</h4>
                        </Col>
                        <Col xs={12} sm={6}>
                            <div className="d-flex flex-wrap justify-content-start justify-content-sm-end gap-2">
                                {(localStorage.getItem("Role") === "5" || localStorage.getItem("Role") === "6") &&
                                    <Link to="/addtransportattendance" className="btn-outline-success green-btn btn-sm">
                                        <i className="fa-solid fa-plus"></i> Add
                                    </Link>
                                }
                                <Link to="/dashboard" className="btn-outline-success red-btn btn-sm">
                                    <i className="fa-solid fa-hand-point-left"></i> Go Back
                                </Link>
                            </div>
                        </Col>
                    </Row>
                </div>

                {vdetail && (
                    <div className="morecontent-section mx-3 mb-3">
                        <h4>Transport Details</h4>
                        <div className="traveldetails">
                            <h3>Vehicle Number<span>: {vdetail.vehicle_no}</span></h3>
                            <h3>Driver<span>: {vdetail.worker_name}</span></h3>
                            <h3>Vehicle Route<span>: {vdetail.vehroute_name}</span></h3>
                            <h3>Mobile No<span>: {vdetail.worker_phone}</span></h3>
                        </div>
                    </div>
                )}

                <div className="counts-wrapper col-sm-4">
                    <div className="count-box total">
                        <div className="number">{totalDays}</div>
                        <div className="label">Total Days</div>
                    </div>
                    <div className="count-box present col-sm-4">
                        <div className="number">{presentCount}</div>
                        <div className="label">Present</div>
                    </div>
                    <div className="count-box absent col-sm-4">
                        <div className="number">{Number.isInteger(absentCount) ? absentCount : absentCount.toFixed(1)}</div>
                        <div className="label">Absent</div>
                    </div>
                </div>

                <div className="mb-4">
                    <Calendar tileContent={tileContent} onActiveStartDateChange={handleMonthChange} />
                </div>

                {localStorage.getItem("Role") === "5" && (
                    <div className="morecontent-section mx-3 mb-3">
                        <h4>Student Attendance </h4>
                        {/* Entered By You */}
                        {groupedEntered.length === 0 ? (
                            <p className="text-center text-danger mt-2">No records found</p>
                        ) : (
                            <div className="table-responsive">
                                <table className="table table-bordered align-middle text-center mt-2">
                                    <thead className="table-light table-head-color">
                                        <tr>
                                            <th>View</th>
                                            <th>Date</th>
                                            <th>Time</th>
                                            <th>Route</th>
                                            {/* <th>Students</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {groupedEntered.map((group) => (
                                            <tr key={group.key}>
                                                <td>
                                                    <i
                                                        className="fa-solid fa-eye text-primary"
                                                        role="button"
                                                        title="View students"
                                                        onClick={() => setModalGroup(group)}
                                                    ></i>
                                                </td>
                                                <td>{group.attendance_date ? moment(group.attendance_date).format("DD-MM-YYYY") : "-"}</td>
                                                <td>{group.attendance_time || "-"}</td>
                                                <td>{group.vehroute_name || "-"}</td>
                                                {/* <td>{group.students.length}</td> */}
                                                
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                )}
            </div>

            <Modal show={!!modalGroup} onHide={() => setModalGroup(null)} centered scrollable>
                <Modal.Header className="d-flex justify-content-between align-items-center">
                    <Modal.Title className="fs-6">
                        {modalGroup && (
                            <>
                                {moment(modalGroup.attendance_date).format("DD-MM-YYYY")} · {modalGroup.attendance_time}
                                {modalGroup.vehroute_name ? ` · ${modalGroup.vehroute_name}` : ""}
                            </>
                        )}
                    </Modal.Title>
                    <i
                        className="fa-solid fa-xmark"
                        role="button"
                        title="Close"
                        style={{ fontSize: "1.25rem", cursor: "pointer" }}
                        onClick={() => setModalGroup(null)}
                    ></i>
                </Modal.Header>
                <Modal.Body>
                    {modalGroup && modalGroup.students.map((item) => (
                        <div className="card shadow-sm mb-3" key={item.id}>
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-start">
                                    <h6 className="mb-1 fw-bold">
                                        {item.student_name || item.uname || item.username}
                                    </h6>
                                    <span className={item.attend_status == 1 ? "result-pass text-white px-2" : "result-fail text-white px-2"}>
                                        {item.attend_status == 1 ? "Present" : "Absent"}
                                    </span>
                                </div>
                                <div className="text-muted small">
                                    {item.class_name || "-"}{item.section_name ? ` - ${item.section_name}` : ""}
                                </div>
                                <div className="small mt-1">
                                    <div><strong>Time:</strong> {item.attendance_time || "-"}</div>
                                    <div><strong>Route:</strong> {item.vehroute_name || "-"}</div>
                                    <div><strong>Vehicle:</strong> {item.vehicle_no || "-"}</div>
                                </div>
                            </div>
                        </div>
                    ))}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" size="sm" onClick={() => setModalGroup(null)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            <Footer />
        </div>
    );
};

export default TransportAttendance;
